<template>
  <div class="nutrients">
    <Head :title="$ml.get(`NUTRIENT CONTENT, %`)" />
    <div>
      <Before :data="general.data.ElementsConcentration"/>
      <After :data="general.data.ElementsConcentration"/>
    </div>
  </div>
</template>

<script>
import Head from './helps/Head.vue';
import Before from './nutPart/Before.vue';
import After from './nutPart/After.vue';

export default {
  props: {
    general: Object
  },
  components: {
    Head,
    Before,
    After
  }
}
</script>

<style lang="scss" scoped>
  .nutrients {
    width: 100%;

    > div:last-child {
      width: 100%;

      .total, .other {
        width: 100%;
      }
      @media (max-width: 768px) {

      }
    }
  }
</style>
